import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const CaregiverGroupsPage = lazy(() => import('@pages/caregiverGroups/CaregiverGroupsPage'));

// Route Component
const CaregiverGroupTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('caregiver-groups-page-title')}>
        <CaregiverGroupsPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  CaregiverGroupTablePage,
};
